import './ServiceableUrls.less';
import { Button, Modal } from 'antd';
import React, { useMemo, useState } from 'react';
import AddUrlsInCluster from './AddUrlsInCluster';
import useGetSettingsForPlan from '../../sales/hooks/useGetPlanSettings';
import { useFetchServiceableUrlsCountQuery } from './service';
import { useFetchUrlClustersQuery } from '../urlClusters/service';
import ModalTitle from '../../components/shared/ModalTitle/ModalTitle';

type Props = {
    websiteGuid: string;
    clusterGuid: string;
};

export default function AddUrlsInClusterButton({ websiteGuid, clusterGuid }: Props) {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const { data: urlClusters } = useFetchUrlClustersQuery({ w_guid: websiteGuid });
    const { data: serviceableUrlsCountData } = useFetchServiceableUrlsCountQuery({ w_guid: websiteGuid });
    const { dpMaxServiceableUrls: maximumServiceableUrls } = useGetSettingsForPlan();

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    const clusterLabel = useMemo(() => urlClusters?.find((cluster) => cluster.guid === clusterGuid)?.title, [clusterGuid, urlClusters]);

    const hasData = !!urlClusters && !!maximumServiceableUrls && !!serviceableUrlsCountData;
    const showButton = hasData && serviceableUrlsCountData.count < maximumServiceableUrls;

    return (
        <>
            {showButton && (
                <>
                    <Button
                        className="deep-analysis-small-button"
                        type="primary"
                        size="small"
                        onClick={toggleModal}
                    >
                        Add new URLs
                    </Button>
                    <Modal
                        visible={isModalVisible}
                        title={
                            <ModalTitle
                                title="Add new URLs"
                                meta={clusterLabel}
                            />
                        }
                        footer={null}
                        onCancel={toggleModal}
                        destroyOnClose={true}
                    >
                        <AddUrlsInCluster
                            websiteGuid={websiteGuid}
                            clusterGuid={clusterGuid}
                            maximumAllowedUrls={maximumServiceableUrls - serviceableUrlsCountData.count}
                            onFinish={toggleModal}
                        />
                    </Modal>
                </>
            )}
        </>
    );
}
